import useDocument from './hook';
import { useMainContext } from './context';
import DocumentView from './DocumentView';
import { Box, CircularProgress } from '@material-ui/core';
import DocumentLayout from './DocumentLayout';

const DocumentPopup = ({ words, isRTL }: any) => {
  const { open, id, docNo, onClose } = useMainContext();
  const { document } = useDocument(id, docNo);
  return (
    <DocumentLayout
      isRTL={isRTL}
      open={open}
      onClose={onClose}
      title={document?.docNo}
    >
      <Box
        style={{
          display: 'flex',
          justifyContent: 'center',
          paddingLeft: 20,
          paddingRight: 20,
          paddingTop: 10,
          paddingBottom: 10,
          width: 1000,
          minHeight: 1500,
        }}
      >
        {!document && <CircularProgress />}
        {document && (
          <DocumentView
            document={document}
            isRTL={isRTL}
            words={words}
          ></DocumentView>
        )}
      </Box>
    </DocumentLayout>
  );
};

export default DocumentPopup;
